import type { ReactNode } from 'react';

interface EmptyStateProps {
    /** Primary message, e.g. "No results found" */
    title: ReactNode;
    /** Secondary explanation or hint */
    description?: ReactNode;
    icon?: ReactNode;
    /** Optional call to action, e.g. a "Create" button */
    action?: ReactNode;
    /** sm: compact left-aligned placeholder for table/list bodies; md: centered block */
    size?: 'sm' | 'md';
    className?: string;
}

/**
 * Consistent "nothing here" placeholder for empty tables, lists, and panels.
 */
const EmptyState = ({ title, description, icon, action, size = 'md', className = '' }: EmptyStateProps) => {
    if (size === 'sm') {
        return (
            <div className={`px-1 py-2 text-sm text-zinc-500 ${className}`}>
                {title}
                {description && <span className="ml-1 text-zinc-600">{description}</span>}
            </div>
        );
    }

    return (
        <div className={`flex flex-col items-center gap-2 py-8 text-center ${className}`}>
            {icon && <div className="text-zinc-600">{icon}</div>}
            <div className="text-zinc-400">{title}</div>
            {description && <div className="text-sm text-zinc-500">{description}</div>}
            {action && <div className="mt-2">{action}</div>}
        </div>
    );
};

export default EmptyState;
